import { atom } from "recoil"
import { ISearchQueryRequest } from "../../models/ISearchQueryRequest"
import { Key } from "../EnumKey"

const searchRequestAtom = atom({
  key: Key.SEARCHQUERY,
  default: {} as ISearchQueryRequest
})

export default searchRequestAtom